export default
{
  pic: ['Foto', 'Photo', 'Foto'],
  of: ['de', 'of', 'de'],
  notConfig: [
    'Já pensou em conhecer a sua silhueta e as peças que te valorizam?\nMe manda uma mensagem e vamos conversar!',
    'Have you thought about knowing your silhouette and the pieces that value you?\nSend me a message and let\'s talk!',
    '¿Has pensado en conocer tu silueta y las piezas que te valoran?\n¡Envíame un mensaje y hablemos!'
  ],
  notConfSendLink: ['Clica aqui', 'Click here', 'Haga clic aquí'],
  notConfSendMessage: [
    ' e me envia um WhatsApp!',
    ' and send me a WhatsApp!',
    ' y envíame un WhatsApp!'
  ]
}



// WEBPACK FOOTER //
// ./src/constants/Perfil.js